import React from 'react';
import SuperAdminDashboard from './SuperAdminDashboard';
import AdminDashboard from './AdminDashboard';
import ClientDashboard from './ClientDashboard';

function Dashboard() {
  // Get user role from localStorage
  const userRole = localStorage.getItem('userRole');

  // Render appropriate dashboard based on role
  if (userRole === 'super_admin') {
    return <SuperAdminDashboard />;
  } else if (userRole === 'third_party_admin' || userRole === 'certification_body') {
    return <AdminDashboard />;
  } else {
    return <ClientDashboard />;
  }
}

export default Dashboard;
